export default __webpack_public_path__ + "static/media/second-step.9294a1d7.svg";